import { useEffect } from 'react';
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { useLocation, useParams } from 'react-router-dom';

import { useBoundStore } from 'app/store';
import { formatNumber } from 'shared/lib';

import { getNoBenefitInfo } from '../api';

export const useControlNonBenefit = () => {
  const { contentCode } = useParams();
  const { hspId, usrId, hsptlzRsvNo } = useBoundStore((state) => state['hsptlzForm'].serviceParams);
  const { data } = useSuspenseQuery({
    queryKey: ['noBenefitInfo', contentCode],
    queryFn: () => {
      if (contentCode === 'P016') return getNoBenefitInfo({ hspId, usrId, hsptlzRsvNo });
      return Promise.resolve({ data: { data: null } });
    },
  });
  const setNonBenefitList = useBoundStore((state) => state['hsptlzForm'].setNonBenefitList);

  useEffect(() => {
    // 비급여 - P016
    if (contentCode === 'P016') {
      if (!data) return;
      const { nonBenefitList } = data.data;
      const BENEFIT_NAME = 'nonBenefitName';
      const nonBenefitWrap = document.querySelector(`[name=${BENEFIT_NAME}]`);
      if (nonBenefitWrap) {
        const nonBenefitItemHTML = nonBenefitList.reduce((pv, cv) => {
          return (
            pv +
            `<li>
      <div class="item-tit">
        <h4>${cv[BENEFIT_NAME]}</h4>
      </div>
      <ul>
        ${cv.nonBenefitDetailList.reduce((dpv, dcv) => {
          return (
            dpv +
            `<li>
              <div>
                <div class="tit">
                  <span>${`[${dcv.nonBenefitDetailCode}][비급여]${dcv.nonBenefitDetailName}`}</span>
                </div>
                <div class="con">
                  <span>${formatNumber(dcv.nonBenefitDetailAmount)}원</span>
                </div>
              </div>
            </li>
            `
          );
        }, '')}
      </ul>
</li>`
          );
        }, '');
        nonBenefitWrap.innerHTML = nonBenefitItemHTML;

        setNonBenefitList(nonBenefitList);
      }
    }
  }, [data]);
};
